import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase.config';
import { UserAuth } from '../context/AuthContext';
import AccountSecurity from './AccountSecurity';

export default function AdminSetup({ card = false }) {
  const { user, isAdmin } = UserAuth();
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let active = true;
    setStatus(null); setError(false);
    if (!user || isAdmin) return () => { active = false; };
    httpsCallable(functions, 'getAdminSetupStatus')({})
      .then(result => { if (active) setStatus(result.data); })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [user, isAdmin, retry]);
  if (card) return status?.allowed ? <section className="mx-auto my-6 max-w-5xl rounded-xl border border-white/20 p-6 text-white">
    <h2 className="text-lg font-medium">Administrator setup</h2>
    <p className="mt-2 font-light">You have been invited to become an administrator. Complete your authenticator setup before access is granted.</p>
    <Link className="mt-3 inline-block text-[#35d99a] underline" to="/account/security">Set up authenticator</Link>
  </section> : null;
  return <main className="min-h-screen bg-[#12181B] px-6 py-16 text-white"><div className="mx-auto max-w-2xl">
    <Link to="/account" className="text-[#35d99a] underline">Back to account</Link>
    {error ? <p role="alert" className="mt-6 font-light">Unable to check your invitation. <button className="underline" onClick={() => setRetry(n => n + 1)}>Try again</button></p>
      : !user || isAdmin || (status && !status.allowed) ? <p className="mt-6 font-light">This setup page is available to invited administrators only.</p>
      : !status ? <p role="status" className="mt-6 font-light">Checking your invitation…</p>
      : <><p className="mt-6 font-light">This invitation lets you set up security. Administrator access is granted separately after setup.</p>
        {status.enrolled ? <p className="mt-6 font-light">Your authenticator is enrolled. Sign out and sign in using its code, then let Ben know you are ready.</p> : <AccountSecurity enrollmentOnly />}</>}
  </div></main>;
}
